import React, { useEffect, useRef } from "react";
import { cookieDeclaration } from "./CookieBotDeclarations.module.css";

type Props = {
  id?: string;
};
export default function CookieBotDeclarations({ id }: Props) {
  if (id === undefined) {
    return null;
  }
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://consent.cookiebot.com/${id}/cd.js`;
    script.type = "text/javascript";
    script.id = "CookieDeclaration";
    ref.current.appendChild(script);
  }, [ref]);

  return <div className={cookieDeclaration} ref={ref}></div>;
}
